import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BadgeStatusVariant =
  | 'default'
  | 'info'
  | 'negative'
  | 'neutral'
  | 'positive'
  | 'warning';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variantClass()',
    class:
      'flex h-[20px] items-center justify-center rounded-[4px] border-[1px] px-[7px] py-[1px] text-[12px] font-semibold uppercase',
  },
  selector: 'aux-badge-status',
  template: `
    {{ label() }}
  `,
})
export class BadgeStatus {
  variantClass = computed(() => {
    switch (this.variant()) {
      case 'default':
      case 'neutral':
        return 'border-[#B2B5C7] bg-aux-gray-light-3 text-aux-gray-dark-1';
      case 'info':
        return 'border-aux-blue-light-4 bg-aux-blue-light-3 text-aux-blue-dark-2';
      case 'negative':
        return 'border-[#FF8480] bg-[#FFF3F2] text-[#BA0003]';
      case 'positive':
        return 'border-[#01CBAD] bg-[#EDFFF1] text-[#08675D]';
      case 'warning':
        return 'border-aux-warn bg-[#FFF1B8] text-aux-red-dark';
    }
  });

  label = input<string>('Default');
  variant = input<BadgeStatusVariant>('default');
}
